<div class="header">
  <h2><i class="fas fa-atlas"></i><span class="label">Custom Domain</span></h2>
</div>
<div class="menu">
  <div class="search">
    <span class="input-group-text"><i class="fas fa-search"></i></span>
    <input
      #searchInput
      type="text"
      placeholder="Search by account ID"
      class="form-control form-control-sm filter-input"
    />
  </div>
  <button type="button" class="btn btn-sm btn-primary" (click)="add()">
    Configure another account
  </button>
</div>
<div class="domains">
  <div class="domains-header">
    <div class="domains-item">Account ID</div>
    <div class="domains-item">Account domain name</div>
    <div class="domains-item"></div>
  </div>
  <div class="domains-row" *ngFor="let account of domainSettings$ | async">
    <div class="domains-item">{{ account?.accountId }}</div>
    <div class="domains-item">{{ account?.domainNames?.account }}</div>
    <div class="domains-item">
      <div class="domains-actions">
        <ng-container
          [ngTemplateOutlet]="actionTemplate"
          [ngTemplateOutletContext]="{
            actionType: ActionType.Edit,
            accountId: account.accountId,
            icon: 'fas fa-edit'
          }"
        ></ng-container>
        <ng-container
          [ngTemplateOutlet]="actionTemplate"
          [ngTemplateOutletContext]="{
            actionType: ActionType.Remove,
            accountId: account.accountId,
            icon: 'far fa-trash-alt'
          }"
        ></ng-container>
        <app-switch-checkbox
          bsSize="sm"
          [checked]="account.enabled"
          (change)="
            toggleSetting({ accountId: account.accountId, enabled: $event })
          "
        ></app-switch-checkbox>
      </div>
    </div>
  </div>
</div>

<ng-template
  #actionTemplate
  let-actionType="actionType"
  let-accountId="accountId"
  let-icon="icon"
>
  <div class="btn-group btn-group-sm" role="group" aria-label="actions">
    <button
      type="button"
      class="btn btn-group btn-group-sm btn-outline-primary btn-sm btn-block"
      (click)="actionClick({ actionType: actionType, accountId: accountId })"
    >
      <i class="action-icon" [ngClass]="icon"></i>
    </button>
  </div>
</ng-template>
